export default __webpack_public_path__ + "15463b25dc20cab5837c52ef1e99c21a.svg";